import React from 'react'
import styled from 'styled-components'

const Caption = ({ children }) => {
  return <Wrapper className="caption">{children}</Wrapper>
}

const Wrapper = styled.p`
  --font-size-caption: var(--font-size-1);
  --font-lineheight-caption: var(--font-lineheight-1);
  --font-weight-caption: var(--font-weight-4);

  font-family: var(--font-sans);
  font-size: var(--font-size-caption);
  line-height: var(--font-lineheight-caption);
  font-weight: var(--font-weight-caption);
  max-width: 40ch;
  margin: 0 auto;
  margin-top: 0.25em;
  color: var(--color-text1-inverted);

  @media (min-width: 768px) {
    --font-size-caption: var(--font-size-3);
    --font-lineheight-caption: var(--font-lineheight-3);
    max-width: 75ch;
  }
`

export default Caption
